import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { isLoggedIn } from "../../utils/isLoggedIn";
import Sale from "./index";
import { isSaleLive, SALE_COUNTDOWN_END } from "./saleConstants";

/** Same destination CheckLogin uses when a member opens the marketing home. */
const MEMBER_HOME = "/blogs/premium/";

/**
 * /sale is only shown while a sale is running.
 * After SALE_COUNTDOWN_END, guests go home and members go to member content.
 */
const PublicSale = () => {
  const [live, setLive] = useState(() => isSaleLive());

  useEffect(() => {
    if (!live) return undefined;
    const delay = Date.parse(SALE_COUNTDOWN_END) - Date.now();
    if (delay <= 0) {
      setLive(false);
      return undefined;
    }
    const id = window.setTimeout(() => setLive(false), delay);
    return () => window.clearTimeout(id);
  }, [live]);

  if (!live) {
    return <Navigate to={isLoggedIn() ? MEMBER_HOME : "/"} replace />;
  }
  if (isLoggedIn()) {
    return <Navigate to={MEMBER_HOME} replace />;
  }
  return <Sale />;
};

export default PublicSale;
